__webpack_require__.p = "/GalaxyEvent/";